import React from 'react';
import { Box } from '@mui/material';
import Verbiage from './Verbiage';

const VerbiageSettings = ({ defaultSettings, onUpdateSettings }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.display && (
        <Verbiage
          settings={defaultSettings.display}
          onUpdateSettings={onUpdateSettings}
        />
      )}
    </Box>
  );
};

export default VerbiageSettings;
